import { map } from 'lodash-es';
import { DateTime } from 'luxon';

import { Assignment } from 'src/common/external/bambi-api/bambiApi';

import { convertAttendantsToAssignedAttendants } from './convertAttendantToAssignedAttendant';
import { convertDriverToAssignedDriver } from './convertDriverToAssignedDriver';
import { convertVehicleToAssignedVehicle } from './convertVehicleToAssignedVehicle';
import { FormValues } from './FormValues';

/** Payload used for both create and update; extra fields are ignored by create. */
type AssignmentFormPayload = Assignment & {
  id?: string;
  driver_call_requests?: never[];
  vehicle_inspections?: never[];
  breaks?: never[];
  trip_count?: number;
  will_call_count?: number;
};

export const convertFormValuesToAssignment = (
  data: FormValues
): AssignmentFormPayload[] => {
  const arrAssignments: AssignmentFormPayload[] = [];
  map(data.assignments, (day) => {
    map(day.assignments, (assignment) => {
      if (day.isEditing && assignment.driver && data.vehicle) {
        const startDateTime = DateTime.fromISO(assignment.start).set({
          month: day.dateTime.month,
          day: day.dateTime.day,
          year: day.dateTime.year,
        });

        const endDateTime = DateTime.fromISO(assignment.end).set({
          month: day.dateTime.month,
          day: day.dateTime.day,
          year: day.dateTime.year,
        });

        arrAssignments.push({
          start: startDateTime.toUTC().toISO(),
          end: endDateTime.toUTC().toISO(),
          driver: convertDriverToAssignedDriver(assignment.driver),
          driver_call_requests: [],
          attendants: convertAttendantsToAssignedAttendants(
            assignment.attendants
          ),
          vehicle: convertVehicleToAssignedVehicle(data.vehicle),
          id: assignment.id,
          vehicle_inspections: [],
          breaks: [],
          trip_count: 0,
          will_call_count: 0,
        });
      }
    });
  });
  return arrAssignments;
};
